import React, { useContext, useEffect } from 'react'
import { DarkModeContext } from '../../global/Theme'

export default function WithdrawViewer({status, amount, name, time}) {
    const { isDark } = useContext(DarkModeContext);

    useEffect(() => {
        if(isDark){
            document.querySelectorAll('#withdrawName').forEach((item, index) => {
                item.style.color = '#BBBDC0'
            })
        } else {
            document.querySelectorAll('#withdrawName').forEach((item, index) => {
                item.style.color = '#000000'
            })
        }
    }, [isDark])
    
    return (
        <div className='transInfo'>
            <div className='transLCol'>
                <p id={(status === 'added') ? 'withdrawName' : 'transLColName'} className={(status === 'withdraw') ? 'withdrawName' : 'transLColName'}>{(name) ? name : 'Added Money'}</p>
                <p className='transLColTime'>{time}</p>
            </div>
            <div className='transRCol'>
                <span id='typeOfTrans' className={`typeOfTrans ${(isDark) ? "darkChip" : "lightChip"}`}>{(status === 'added') ? 'Request' : (status === 'tip') ? 'Tip Sent' : 'Subscribed'}</span>
                {(status !== 'added') ? <img src={require('../../assets/icons/circleMinus.svg')} /> : <img src={require('../../assets/icons/circlePlus.svg')} />}
                <p id='transMoney' className={(status === 'added') ? 'money-added' : 'money-withdraw'}>{`$${amount}`}</p>
            </div>
        </div>
    )
}
